
import { Button } from "@/components/ui/button";
import { MessageSquare } from 'lucide-react';

interface SuccessViewProps {
  onClose: () => void;
}

const SuccessView = ({ onClose }: SuccessViewProps) => {
  return (
    <div className="py-8 text-center space-y-6 animate-fadeIn">
      <div className="text-6xl">🎉</div>
      <h2 className="text-2xl font-bold text-deepseek-primary">
        You are selected!
      </h2>
      <p className="text-lg text-gray-600">
        Thanks for joining!
      </p>
      <div className="flex flex-col items-center space-y-4">
        <Button
          onClick={() => window.open('https://buy.stripe.com/8wM6rHauV3nL96EcMQ', '_blank')}
          className="bg-[#2ab540] hover:bg-[#239435] text-white font-semibold px-8 py-6 text-lg rounded-full transition-all duration-200 transform hover:scale-105 w-[80%] flex items-center justify-center gap-3"
        >
          <MessageSquare size={24} strokeWidth={2} className="text-white" />
          <span>Try DeepSeek AI on WhatsApp</span>
        </Button>
        <Button
          onClick={onClose}
          variant="outline"
          className="w-auto"
        >
          Close
        </Button>
      </div>
    </div>
  );
};

export default SuccessView;
